import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-llm-playground',
    templateUrl: './llm-playground.component.html',
    styleUrls: ['./llm-playground.component.scss'],
    imports: [RouterOutlet]
})
export class LlmPlaygroundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
